import React from "react";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function Products() {
  const [products, setProducts] = React.useState([]);
  React.useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="hero-mesh grain">
        <div className="container-wide py-20 md:py-28">
          <div className="overline">Our products</div>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-4xl">Ready-to-deploy platforms, powered by real client engagements.</h1>
          <p className="mt-6 max-w-2xl text-[color:var(--sky-muted)] text-lg leading-relaxed">
            Skyverra products are hardened, extensible platforms we license to teams that want a fast start
            without giving up customization.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-wide grid gap-10">
          {products.map((p, i) => (
            <div key={p.id} className={`card-flat overflow-hidden grid lg:grid-cols-2 ${i % 2 ? 'lg:[direction:rtl]' : ''}`}>
              <div className="aspect-[16/10] lg:aspect-auto overflow-hidden [direction:ltr]">
                {p.image_url ? (
                  <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full bg-[color:var(--sky-navy)]/10" />
                )}
              </div>
              <div className="p-8 md:p-10 [direction:ltr]">
                <div className="overline">{p.category}</div>
                <h2 className="mt-3 font-display font-bold text-3xl tracking-tight">{p.name}</h2>
                <p className="mt-2 text-[color:var(--sky-navy)] font-medium">{p.tagline}</p>
                <p className="mt-5 text-sm text-[color:var(--sky-muted)] leading-relaxed">{p.description}</p>

                {p.features && p.features.length > 0 && (
                  <ul className="mt-6 grid gap-2 sm:grid-cols-2">
                    {p.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm">
                        <Check size={14} className="mt-0.5 text-[color:var(--sky-cyan)]" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
